/**
 * Live "is this robot on the charger" flag, shared by flows that must
 * hard-block an action while charging (dispatch delivery, patrol).
 * Seeded from the robot record, then kept live via SENSOR_STATUS_UPDATE.
 */
import { useEffect, useState } from "react";
import { getSocket } from "../services/socketService";

export const useRobotCharging = (serialID, robot) => {
  const [isRobotCharging, setIsRobotCharging] = useState(!!robot?.charging);

  // Re-seed whenever the selected robot changes, so switching robots doesn't
  // carry over the previous robot's charging flag until a fresh event arrives.
  useEffect(() => {
    setIsRobotCharging(!!robot?.charging);
  }, [robot?.serialID, robot?.charging]);

  useEffect(() => {
    if (!serialID) return undefined;

    const socket = getSocket();
    const onSensorStatus = (msg) => {
      const sid = msg?.serialID;
      if (sid != null && String(sid) !== String(serialID)) return;
      if (typeof msg?.charging === "boolean") setIsRobotCharging(msg.charging);
    };
    socket.on("SENSOR_STATUS_UPDATE", onSensorStatus);
    // Ask for the last known value in case the robot is between packets.
    socket.emit("frontend:get-SENSOR_STATUS", { serialID });

    return () => {
      socket.off("SENSOR_STATUS_UPDATE", onSensorStatus);
    };
  }, [serialID]);

  return isRobotCharging;
};

export default useRobotCharging;
